export default class Modal {
  modalTriggers = $('.js-modal');
  modalCloseTriggers = $('.js-close-modal');
  modals = $('.modal');
  bodyRef = $('body');

  constructor() {
    if (this.modals.length && this.bodyRef) {
      // Disable open/close functionality when clicked inside container
      $('.modal .modal-content-wrap').on('click', event => event.stopPropagation());

      // Close modal when user click on overlay
      this.bodyRef.on('click', '.modal .modal-overlay', () => {
        this.closeModal();
      });

      // Close modal by trigger
      this.modalCloseTriggers.on('click', this.closeModal.bind(this));

      // Open modal
      this.modalTriggers.on('click', this.openModal.bind(this));
    }
  }

  closeModal() {
    $('.modal').removeClass('opened');
  }

  openModal(ev: Event) {
    const modalId = (<HTMLElement>ev.currentTarget).dataset.modal;
    $(`#${modalId}`).addClass('opened');
  }
}
